import React from "react";
import { adminTheme } from "./adminTheme";

type SectionCardProps = {
  title?: string;
  description?: string;
  message?: string;
  eyebrow?: string;
  children: React.ReactNode;
};

export default function SectionCard({
  title,
  description,
  message,
  eyebrow,
  children,
}: SectionCardProps) {
  const body = description ?? message;

  return (
    <section
      style={{
        background: adminTheme.color.surface,
        border: `1px solid ${adminTheme.color.border}`,
        borderRadius: adminTheme.radius.lg,
        padding: adminTheme.space.xxl,
        display: "flex",
        flexDirection: "column",
        gap: adminTheme.space.xl,
        boxShadow: adminTheme.shadow.sm,
      }}
    >
      {eyebrow || title || body ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: adminTheme.space.xs,
            paddingBottom: "2px",
          }}
        >
          {eyebrow ? (
            <span
              style={{
                fontSize: adminTheme.type.eyebrow,
                fontWeight: 800,
                color: adminTheme.color.textFaint,
                textTransform: "uppercase",
                letterSpacing: "0.08em",
              }}
            >
              {eyebrow}
            </span>
          ) : null}

          {title ? (
            <h2
              style={{
                margin: 0,
                fontSize: adminTheme.type.titleMd,
                lineHeight: 1.25,
                letterSpacing: "-0.02em",
                color: adminTheme.color.text,
              }}
            >
              {title}
            </h2>
          ) : null}

          {body ? (
            <p
              style={{
                margin: 0,
                color: adminTheme.color.textMuted,
                lineHeight: 1.65,
                maxWidth: "68ch",
              }}
            >
              {body}
            </p>
          ) : null}
        </div>
      ) : null}

      {children}
    </section>
  );
}